// extracted by mini-css-extract-plugin
export default {"wrapper":"knowleageBaseMenu_wrapper__AJRDw","category":"knowleageBaseMenu_category__KYQmF","article":"knowleageBaseMenu_article__65OQV"};